import $ from "jquery";

$(function () {

    // Production load more / filters functionality
    let paged = 2;
    let activeFilter = 'all'; // default

    // Current Tab
    $('#tab-current').on('click', function() {
        activeFilter = 'current';
        paged = 1;
        $(".production-tab").removeClass("active");
        $(this).addClass("active");
        $('.production-list #card-container').empty();
        loadMorePosts();
    });

    // All Tab
    $('#tab-all').on('click', function() {
        activeFilter = 'all';
        paged = 1;
        $(".production-tab").removeClass("active");
        $(this).addClass("active");
        $('.production-list #card-container').empty();
        loadMorePosts();
    });

    // Load More button
    $('#load-more-btn').on('click', function(e) {
        e.preventDefault();
        loadMorePosts();
    });

    function loadMorePosts() {
        $.ajax({
            url: AKA_ajax.url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'load_more_productions',
                paged: paged,
                filter: activeFilter,
            },
            beforeSend: function() {
                $('#load-more-btn').text('Loading...');
            },
            success: function(response) {
                console.log('Response:', response);

                if (response.content.trim() === '') {
                    $('#load-more-btn').hide();
                } else {
                    $('.production-list #card-container').append(response.content);
                    $('#load-more-btn').text('Load More');
                    paged++; // Increment to the next page

                    // Check if we've loaded everything for this filter
                    let totalLoadedPosts = $('.production-list #card-container .card-tile').length;
                    if (totalLoadedPosts >= response.total_posts) {
                        $('#load-more-btn').hide();
                    } else {
                        $('#load-more-btn').show();
                    }
                }
            }
        });
    }
});

